<template>
  <section class="_menu-section-style">
    <form-section label="Opções" v-model="isExpanded.options">
      <v-row no-gutters>
        <v-col cols="12">
          <TextField v-model="selectedSection.listMsg" label="Descrição campo"/>            
        </v-col>

        <!-- Comentado por enquanto, pois todos campos sao obrigatorios  -->
        <!-- <v-col cols="12" class="pb-4">
          <Select 
            label="Campos do formulário"
            placeholder="Escolha os campos"
            multiple
            v-model="selectedSection.formOptions" 
            item-value="id"
            item-text="label"
            :items="formOptions" 
            :showBorder="true"
            useSelectionTemplate
            useItemTemplate
            @change="onSelectFormFields"
          >
            <template v-slot:selection="{index}">
              <span v-if="index === 0">{{selectedSection.formOptions.length}} selecionados</span>
            </template>

            <template v-slot:item="{ item, attrs }">
              <div class="d-flex py-2" style="width: 200px; z-index: 10">
                <div style="position: relative; z-index: 1 !important">
                  <div style="position: absolute; width: 100%; height: 100%; z-index: 100"></div>
                  <Checkbox v-model="attrs.inputValue" :id="attrs.id"/>
                </div>
                <div class="pl-3" style="font-size: 0.9rem">{{item.label}}</div>
              </div>
            </template>              
          </Select>
        </v-col> -->

        <v-col cols="12" class="pt-4">
          <Select 
            label="Listas do CRM"
            placeholder="Selecione uma lista"
            multiple
            v-model="selectedSection.lists" 
            item-value="_codigo"
            :items="crmList" 
            :showBorder="true"
            useSelectionTemplate
            useItemTemplate
            noDataText="Nenhuma lista pública disponível"
          >
            <template v-slot:selection="{index}">
              <span v-if="index === 0">{{selectedSection.lists.length}} selecionados</span>
            </template>

            <template v-slot:item="{ item, attrs }">
              <div class="d-flex py-2 align-center" style="width: 200px; z-index: 10">
                <div style="position: relative; z-index: 1 !important">
                  <div style="position: absolute; width: 100%; height: 100%; z-index: 100"></div>
                  <Checkbox v-model="attrs.inputValue" :id="attrs.id"/>
                </div>
                <div class="pl-3" style="font-size: 0.9rem">
                  <span class="d-block">{{item.nome}}</span>
                  <span v-if="item.codigo_grupo !== 0" class="d-block grey--text" style="font-size: 0.7rem !important">
                    {{item.nome_grupo}}
                  </span>
                </div>
              </div>
            </template>              
          </Select>
        </v-col>
      </v-row>

    </form-section>

    <form-section label="Alinhamento" v-model="isExpanded.alignment">
      <Alignment :selectedSection="selectedSection" :hide="['vertical']"/>
    </form-section>

    <form-section label="Título" v-model="isExpanded.title">
      <Texts textType="title" :sectionType="selectedSection.type" :selectedSection="selectedSection" :hide="['alignment']"/>
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts textType="subtitle" :sectionType="selectedSection.type" :selectedSection="selectedSection" :hide="['alignment']"/>
    </form-section>

    <form-section label="Texto" v-model="isExpanded.text">
      <Texts textType="text" :sectionType="selectedSection.type" :selectedSection="selectedSection" :hide="['alignment']"/>
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>

    <form-section label="Formulário" v-model="isExpanded.form" :divider="false">
      <v-row no-gutters>
        <v-col cols="6" class="_pr-">
          <ColorPickerV2 title="Cor de fundo" :colorSelected="selectedSection" type="layer-color" />             
        </v-col>
        <v-col cols="6" class="_pl-">
          <ColorPickerV2 title="Cor do texto" :colorSelected="selectedSection" type="text-color" />             
        </v-col>

        <v-col v-if="!hasBindedStyle" cols="6" class="_pt _pr-">
          <ColorPickerV2 title="Cor botão" :colorSelected="selectedSection.buttons[0]" type="background-color" />             
        </v-col>
        <v-col v-if="!hasBindedStyle" cols="6" class="_pt _pl-">
          <ColorPickerV2 title="Cor de texto botão" :colorSelected="selectedSection.buttons[0]" type="color" />             
        </v-col>
        <v-col v-if="!hasBindedStyle" cols="6" class="_pt _pr-">
          <TextField 
            v-model="fontSize.buttonBorderRadius"
            label="Borda do botão"
            placeholder="px"
            type="number"
            :minValueForNumber="0"
            @input="updateSize($event, selectedSection.buttons[0], 'border')"
          />            
        </v-col>
      </v-row>
    </form-section>    
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { CRM_FORM_OPTIONS, CRM_SELECTED_LISTS_INFO } from '../../../schemas/sections'
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import ColorPickerV2 from '../../_v2/ui/ColorPickerV2.vue'
import TextField from '../../_v2/ui/TextField.vue'
import Alignment from '../forms/formsV2/Alignment.vue'
import Select from '../../_v2/ui/Select.vue'
import Checkbox from '../../_v2/ui/Checkbox/Checkbox.vue'

export default {
  name: 'ContactSection',
  components: { FormSection, Texts, Background, ColorPickerV2, TextField, Select, Alignment, Checkbox },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  computed: {
    ...mapGetters(['crmList', 'loadingCrm']),
    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    }
  },  

  data: () => ({
    fontSize: { buttonBorderRadius: '' },
    isExpanded: {options: true, alignment: false, title: false, subtitle: false, text: false, bg: false, form: false},
    formOptions: CRM_FORM_OPTIONS()    
  }),

  mounted () {
    this.formatOnInit()
  },

  watch: {
    'selectedSection.lists'(v) {
      const infoList = this.crmList.filter(list => v.includes(list._codigo))
      this.selectedSection.selectedListsInfo = infoList.map(list => {
        return CRM_SELECTED_LISTS_INFO({codigo: list._codigo, nome: list.nome, token: list.token})
      })
    }
  },

  methods: {
    onSelectFormFields() {
      this.selectedSection.formOptions = this.selectedSection.formOptions.sort((a, b) => a - b)
    },

    formatOnInit() {
      if (this.selectedSection.buttons[0]["border-radius"]) {
        this.fontSize.buttonBorderRadius = this.selectedSection.buttons[0]["border-radius"].split("px")[0]
      }
    },

    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    updateSize(event, type, border) {
      let model = "";
      model = event + "px";
      if (border === "border") type["border-radius"] = model;
      else type["font-size"] = model;
    }    
  }    
}
</script>

<style scoped>
</style>